import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiChevronRight, FiHome } = FiIcons;

/**
 * Breadcrumbs Component
 * Provides navigation breadcrumbs with schema.org markup for SEO
 */
export default function Breadcrumbs({ items }) {
  // Generate BreadcrumbList schema
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.path && { item: `https://www.greengasturbines.com${item.path}` })
    }))
  };

  return (
    <>
      {/* Inject schema for SEO */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />

      <nav aria-label="Breadcrumb" className="mb-6">
        <ol className="flex items-center space-x-2 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              {index > 0 && (
                <SafeIcon 
                  icon={FiChevronRight} 
                  className="h-4 w-4 text-gray-400 mx-2" 
                />
              )}
              {item.path ? (
                <Link
                  to={item.path}
                  className="text-primary-600 hover:text-primary-700 transition-colors flex items-center"
                >
                  {index === 0 && (
                    <SafeIcon icon={FiHome} className="h-4 w-4 mr-1" />
                  )}
                  {item.label}
                </Link>
              ) : (
                <span className="text-gray-600 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}
